import React, {useContext} from 'react'

import StoryContext from '../store/context'
import {observer} from 'mobx-react-lite'

const Home = observer(() => {
  const store = useContext(StoryContext)
  return <div></div>
})

export default Home
